module.exports = __webpack_public_path__ + "static/media/main_illus.3602d925.png";